import { styled } from "styled-components";

import { ai_graphic_enabled } from "../../shared/gradient/ai-graphic";

export const Wrapper = styled.div``;

export const GradientBorderWrapper = styled.div<{
  $radius: string;
  $borderWidth: string;
}>`
  width: 100%;
  height: 100%;
  padding: ${({ $borderWidth }) => $borderWidth};
  border-radius: ${({ $radius }) => $radius};
  background: ${ai_graphic_enabled};
  background-size: cover;
  background-position: center;
  background-repeat: repeat;
`;

export const GradientBorderContent = styled.div<{ $radius: string }>`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: ${({ $radius }) => `calc(${$radius} - 0.2rem)`};
  overflow: hidden;
`;

export const DefaultBorderWrapper = styled.div<{
  $radius: string;
  $borderWidth: string;
  $borderColor: string;
}>`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: ${({ $radius }) => $radius};
  border: ${({ $borderWidth, $borderColor }) =>
    `${$borderWidth} solid ${$borderColor}`};
  overflow: hidden;
`;
